import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityEmpresaDGIState
} from './empresas-dgi.state';
import { entityEmpresaDGIAdapter } from './empresas-dgi.state';
import {
  entityEmpresaDGILoadRequest,
  entityEmpresaDGILoadSuccess,
  entityEmpresaDGILoadFailure,
  entityEmpresaDGISetEmpty
} from './empresas-dgi.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityEmpresaDGILoadRequest, (state) => ({
    ...initialState,
    isLoading: true,
    error: null
  })),
  on(entityEmpresaDGILoadFailure, (state, { error }) => ({
    ...initialState,
    isLoading: false,
    error: error
  })),
  on(entityEmpresaDGILoadSuccess, (state, { item }) =>
    entityEmpresaDGIAdapter.addOne(item, {
      ...initialState,
      isLoading: false,
      error: null
    })
  ),
  on(entityEmpresaDGISetEmpty, (state, {}) =>
    entityEmpresaDGIAdapter.removeAll({
      ...initialState,
      isLoading: false,
      error: null
    })
  )
);

export function empresaDGIReducer(
  state: EntityEmpresaDGIState | undefined,
  action: Action
) {
  return reducer(state, action);
}

